<template>
    <div align="center" class="limiter animated fadeIn" id="currentStatus" :class="this.$route.query.v">
        <div class="container-login100">
            <div class="wrap-login100 p-l-50 p-r-50 p-t-77 p-b-30">
                <div class="login100-form validate-form justify-content-center">
                    <div align="center" class="containerLogo">
                        <img class="dashboardLogoHold" :src="logo">
                        </img>
                    </div>
                    <span class="login100-form-title p-b-15">
                        <div id="welcomeMsg" class="mb-3">
                            Bienvenido {{ user.name }}
                            <br>
                                <small class="chargue">
                                    ({{ user.company.name }})
                                </small>
                            </br>
                        </div>
                        <div v-if="user.profilepicture">
                            <br>
                                <br>
                                    <img class="dashboardAvatar" :src="'https://admin.tracketiza.com/wservice/' + user.profilepicture">
                                </br>
                            </br>
                        </div>
                      <div v-else>
                            <br>
                                <br>
                                    <img class="dashboardAvatar" :src="'/static/images/avatar.png'">
                                </br>
                            </br>
                        </div>

                        <small class="subString">
                            <div class="alert alert-danger" role="alert">
                                Salida de cuenta automática en (
                                <span id="counterTime">
                                    {{ this.timeLogout }}
                                </span>
                                segundos )
                            </div>
                        </small>
                    </span>
                    <div class="row my-2">
                        <div class="col-md-12">
                            <div class="card currentStatus">
                                <div class="card-header" style="">
                                    <h4 style="color:black;">
                                        Estado Actual
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <blockquote class="blockquote mb-0" id="currentStatusCard" style="color:black">
                                        <p id="currentStatusString" v-if="statusInfo && statusInfo.actualStatus && statusInfo.actualStatus.status == 'Ocupado'">
                                            {{ statusInfo.actualStatus.hourtime }}
                                        </p>

                                        <h3 id="currentStatusTimeData">
                                            <span v-if="statusInfo && statusInfo.actualStatus && statusInfo.actualStatus.status == 'Ocupado'">Fichado</span>
                                            <span v-else-if="statusInfo && statusInfo.actualStatus && statusInfo.actualStatus.status == 'Pausa'">Pausa</span>
                                            <span v-else>No Fichado</span>
                                        </h3>
                                        <p>
                                        </p>
                                        <footer class="blockquote-footer">
                                            <small>
                                                Durante la jornada de hoy
                                                <br>
                                                    (
                                                    <span class="currentDay">
                                                        {{ today.format('dddd') | capitalize }} {{ today.format('DD/M/Y') }}
                                                    </span>
                                                    )
                                                </br>
                                            </small>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-md-6">
                            <div :class="{'active': statusInfo && statusInfo.actualStatus && statusInfo.actualStatus.status == 'Ocupado'}" class="card firstCard">
                                <div class="card-header cardHeaderdash">
                                    <h4>
                                        Tiempo Trabajado
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <blockquote class="blockquote mb-0">
                                        <p>
                                        </p>
                                        <h3 id="workTime">
                                            <span v-if="todayMetrics && todayMetrics.totalwork != '00:00:00'">
                                                {{ todayMetrics.totalwork }}
                                            </span>
                                            <span v-else>
                                                {{ workedDiff.format('HH') }} h {{ workedDiff.format('mm') }} min
                                            </span>
                                        </h3>
                                        <p>
                                        </p>
                                        <footer class="blockquote-footer">
                                            <small>
                                                Durante la jornada de hoy
                                                <br>
                                                    (
                                                    <span class="currentDay">
                                                        {{ today.format('dddd') | capitalize }} {{ today.format('DD/M/Y') }}
                                                    </span>
                                                    )
                                                </br>
                                            </small>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div :class="{'active': statusInfo && statusInfo.actualStatus && statusInfo.actualStatus.status == 'Pausa'}" class="card firstCard">
                                <div class="card-header secondHeaderDash">
                                    <h4>
                                        Tiempo Pausa
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <blockquote class="blockquote mb-0">
                                        <p>
                                        </p>
                                        <h3 id="pauseTime">
                                            <span v-if="todayMetrics && todayMetrics.totalpause != '00:00:00'">
                                                {{ todayMetrics.totalpause }}
                                            </span>
                                            <span v-else>
                                                {{ pauseDiff.format('HH') }} h {{ pauseDiff.format('mm') }} min
                                            </span>
                                        </h3>
                                        <p>
                                        </p>
                                        <footer class="blockquote-footer">
                                            <small>
                                                Durante la jornada de hoy
                                                <br>
                                                    (
                                                    <span class="currentDay">
                                                        {{ today.format('dddd') | capitalize }} {{ today.format('DD/M/Y') }}
                                                    </span>
                                                    )
                                                </br>
                                            </small>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-md-6">
                            <div class="card firstCard">
                                <div class="card-header thirdHeaderDash">
                                    <h4>
                                        Check - In
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <blockquote class="blockquote mb-0">
                                        <p>
                                        </p>
                                        <h3 id="checkInData">
                                            <span v-if="todayMetrics && todayMetrics.timeInFirst">
                                                {{ todayMetrics.timeInFirst }}
                                            </span>
                                            <span v-else>
                                                00 h 00 min
                                            </span>
                                        </h3>
                                        <p>
                                        </p>
                                        <footer class="blockquote-footer">
                                            <small>
                                                Durante la jornada de hoy
                                                <br>
                                                    (
                                                    <span class="currentDay">
                                                        {{ today.format('dddd') | capitalize }} {{ today.format('DD/M/Y') }}
                                                    </span>
                                                    )
                                                </br>
                                            </small>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card firstCard">
                                <div class="card-header fourthHeaderDash">
                                    <h4>
                                        Check - Out
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <blockquote class="blockquote mb-0">
                                        <p>
                                        </p>
                                        <h3 id="checkOutData">
                                            <span v-if="todayMetrics && todayMetrics.timeOutFirst">
                                                {{ todayMetrics.timeOutFirst }}
                                            </span>
                                            <span v-else>
                                                00 h 00 min
                                            </span>
                                        </h3>
                                        <p>
                                        </p>
                                        <footer class="blockquote-footer">
                                            <small>
                                                Durante la jornada de hoy
                                                <br>
                                                    (
                                                    <span class="currentDay">
                                                        {{ today.format('dddd') | capitalize }} {{ today.format('DD/M/Y') }}
                                                    </span>
                                                    )
                                                </br>
                                            </small>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>


                  <!--  <div class="row my-2" v-if="this.user.grouptime && this.user.grouptime.type == 'Partido'">-->
                    <div class="row my-2" v-if="1==1">
                        <div class="col-md-6">
                            <div class="card firstCard">
                                <div class="card-header thirdHeaderDash">
                                    <h4>
                                        Check - In (Partido)
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <blockquote class="blockquote mb-0">
                                        <p>
                                        </p>
                                        <h3 id="checkInData">
                                            <span v-if="todayMetrics && todayMetrics.timeInSecond">
                                                {{ todayMetrics.timeInSecond }}
                                            </span>
                                            <span v-else>
                                                00 h 00 min
                                            </span>
                                        </h3>
                                        <p>
                                        </p>
                                        <footer class="blockquote-footer">
                                            <small>
                                                Durante la jornada de hoy
                                                <br>
                                                    (
                                                    <span class="currentDay">
                                                        {{ today.format('dddd') | capitalize }} {{ today.format('DD/M/Y') }}
                                                    </span>
                                                    )
                                                </br>
                                            </small>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card firstCard">
                                <div class="card-header fourthHeaderDash">
                                    <h4>
                                        Check - Out (Partido)
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <blockquote class="blockquote mb-0">
                                        <p>
                                        </p>
                                        <h3 id="checkOutData">
                                            <span v-if="todayMetrics && todayMetrics.timeOutSecond">
                                                {{ todayMetrics.timeOutSecond }}
                                            </span>
                                            <span v-else>
                                                00 h 00 min
                                            </span>
                                        </h3>
                                        <p>
                                        </p>
                                        <footer class="blockquote-footer">
                                            <small>
                                                Durante la jornada de hoy
                                                <br>
                                                    (
                                                    <span class="currentDay">
                                                        {{ today.format('dddd') | capitalize }} {{ today.format('DD/M/Y') }}
                                                    </span>
                                                    )
                                                </br>
                                            </small>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container-login100-form-btn p-t-25">
<!--
                        <button class="login100-form-btn" @click="initiateLog()" v-if="user.statustime == null || (this.statusInfo && !this.statusInfo.isOut1 || (this.user.grouptime && this.user.grouptime.type == 'Partido' && this.statusInfo && !this.statusInfo.isOut2)) && (this.todayMetrics && !this.todayMetrics.timeInSecond && !this.todayMetrics.timePutSecond)">
-->
                        <button class="login100-form-btn" @click="initiateLog()" >
                            Fichar
                        </button>
                        <br>
                            <br>
                                <br>
                                    <br>
                                        <a class="btn-face m-b-10" @click="reload();" style="width: 100%;">
                                            Salir de mi Cuenta
                                        </a>
                                    </br>
                                </br>
                            </br>
                        </br>
                    </div>
                </div>
                <small class="copyFooter">
                    <span class="Year">
                        2020
                    </span>
                    © {{ copy }} | ver 1.0.1a
                </small>
            </div>
        </div>

        <div class="modal" id="modalStatus" role="dialog" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Selecciona el estado
                        </h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">
                                ×
                            </span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="statusInfo">
                        <p>
                            <button v-if="!this.statusInfo.actualStatus || (this.statusInfo && this.statusInfo.actualStatus && (this.statusInfo.actualStatus.status == 'Libre'))" class="btn btn-primary btn-lg btn-block my-4" @click="setStatus(1)" style="background-color: #7966FE;border-color: transparent;" type="button">
                                Comenzar Jornada
                            </button>
                              <button v-if="this.statusInfo && this.statusInfo.actualStatus && (this.statusInfo.actualStatus.status == 'Pausa')" class="btn btn-primary btn-lg btn-block my-4" @click="setStatus(1)" style="background-color: #7966FE;border-color: transparent;" type="button">
                                Reanudar Jornada
                            </button>
                            <button v-if="this.statusInfo && this.statusInfo.actualStatus && (this.statusInfo.actualStatus.status == 'Ocupado')" class="btn btn-info btn-lg btn-block my-4" @click="setStatus(2)" type="button">
                                Registrar Tiempo de Pausa
                            </button>
                            <button v-if="this.statusInfo && this.statusInfo.actualStatus && (this.statusInfo.actualStatus.status == 'Pausa' || this.statusInfo.actualStatus.status == 'Ocupado')" class="btn btn-danger btn-lg btn-block my-4" @click="setStatus(0)" type="button">
                                Finalizar Jornada
                            </button>
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" data-dismiss="modal" type="button">
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Api from '../api.js'
import { mapState } from 'Vuex'

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

import JQuery from 'jquery'
let $ = JQuery

export default {
    name: 'AppComponent',
    data () {
        return {
            today: moment().utc(),
            timeLogout: 59,
            actualTime: moment().utc(),
            now: moment().utc(),
            workedDiff: moment().utc().utcOffset(0).set({hour:0,minute:0,second:0,millisecond:0}),
            pauseDiff: moment().utc().utcOffset(0).set({hour:0,minute:0,second:0,millisecond:0}),
            first: true,
            logo: '',
            copy: '',
        }
    },
    computed: {
        ...mapState({
            user: state => state.user,
            statusInfo: state => state.statusInfo,
            todayMetrics: state => state.todayMetrics,
        })
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    mounted() {
        var instance = this
        localStorage.setItem('position', 'Ubicando operador...');

        this.getStatusInfo()

        if(this.$route.query.v != 'meetcontrol') {
          this.getCurrentLocation()
        }

        setInterval(function() {
            instance.time()
            //instance.getTodayMetrics()
        }, 1000)
    },
    methods: {
        initiateLog() {
            $('#modalStatus').modal('toggle');
        },
        getStatusInfo() {
            var instance = this
            Api.apiCall(apiUrl + '/operators/' + this.user.uniqueid + '/status-info').then(res => {
                this.$store.dispatch('setStatusInfo', res.statusInfo)
                if (res.statusInfo.actualStatus) {
                    this.actualTime = moment(res.statusInfo.actualStatus.hourtime, 'DD-MM-YYYY HH:mm:ss')
                }

                this.pauseDiff = moment(this.today.format('DD-MM-Y') + ' ' + res.statusInfo.metricdata.totalpause, 'DD-MM-Y HH:mm:ss')
                this.workedDiff = moment(this.today.format('DD-MM-Y') + ' ' + res.statusInfo.metricdata.totalwork, 'DD-MM-Y HH:mm:ss')

                this.getTodayMetrics()
            })
        },
        setStatus(type) {
            var instance = this
            $('#modalStatus').modal('toggle');
            var userid = this.user.uniqueid;
            var location = localStorage.getItem('position');
            var b64 = null
            var typeHold = type;
            var str = '';
            switch (type) {
                case 0:
                    type = 'Libre';
                    str = 'No Fichado';
                    break;
                case 1:
                    type = 'Ocupado';
                    str = 'Fichado Correctamente'
                    break;
                case 2:
                    type = 'Pausa';
                    str = 'Registrado Tiempo de Pausa';
                    break;
            }
            //str = el aviso del registro
            $.post(serverUrl, {
                opt: '/setLogEvent',
                userid: userid,
                location: location,
                b64: b64,
                extension: 'jpg',
                status: typeHold,
                addTime: null
            }, function(data) {
                instance.$swal.fire('Estado Actualizado Correctamente', '', 'success');
                instance.getStatusInfo()
            });
        },
        getCurrentLocation() {
            var array = new Array();
            localStorage.setItem('position', 'Ubicando operador...');
            navigator.geolocation.getCurrentPosition(function(location) {
                array[0] = location.coords.latitude;
                array[1] = location.coords.longitude;
                array[2] = location.coords.accuracy;
            });
            navigator.geolocation.getCurrentPosition(function(location) {
                array[0] = location.coords.latitude;
                array[1] = location.coords.longitude;
                array[2] = location.coords.accuracy;
                $.post(serverUrl, {
                    opt: '/getAddress',
                    lat: array[0],
                    long: array[1]
                }, function(data) {
                    if (data == null || data == '' || data == 'null') {
                        localStorage.setItem('position', 'Ubicando operador...');
                    }
                    localStorage.setItem('position', data);
                });
            });
        },
        getTodayMetrics() {
            Api.apiCall(apiUrl + '/metrics/general-for-export', {
                companyid: this.user.company.sessionid,
                operatorid: this.user.uniqueid,
                range: this.today.format('DD/MM/Y') + ' - ' + this.today.format('DD/MM/Y')
            }).then(res => {
                this.$store.dispatch('getTodayMetrics', res[0])
                var todayMetrics = res[0]
                var instance = this
            })
        },
        time(first) {
            if (this.statusInfo && this.statusInfo.actualStatus && this.statusInfo.actualStatus.status == 'Ocupado') {
                this.workedDiff.add(1, 'seconds')
                this.$forceUpdate()
            }
            if (this.statusInfo && this.statusInfo.actualStatus && this.statusInfo.actualStatus.status == 'Pausa') {
                this.pauseDiff.add(1, 'seconds')
                this.$forceUpdate()
            }
        },
        reload() {
            this.$router.push({path: '/', query: { v: this.$route.query.v }})
        }
    },

    created () {
        var timeout
        var instance = this
        function refresh(){
            clearTimeout(timeout)
            instance.timeLogout = 59
        }

        setInterval(i => {
            if (instance.timeLogout == 0) {
                instance.$router.push({path: '/', query: { v: instance.$route.query.v }})
            }
            instance.timeLogout--
        }, 1000)
        refresh()
        document.addEventListener('click', refresh)
        document.addEventListener('mousemove', refresh)

        if(this.$route.query.v == 'meetcontrol') {
            this.logo = "/static/images/meetcontrol.png"
            this.copy = "MeetControl"
        } else {
            this.logo = "/static/images/logoOriginal.png"
            this.copy = ""
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/AppComponent.vue